export const PROJECT_DETAILS_INIT = 'PROJECT_DETAILS_INIT';
export const PROJECT_DETAILS_CURRENT_PROJECT_SET =
  'PROJECT_DETAILS_CURRENT_PROJECT_SET';
export const PROJECT_DETAILS_NAV_BAR_SELECTION =
  'PROJECT_DETAILS_NAV_BAR_SELECTION';
export const SHOW_PDF_VIEWER_SET = 'SHOW_PDF_VIEWER_SET';
export const DIRECT_UPLOAD_IN_PROCESS = 'DIRECT_UPLOAD_IN_PROCESS';
export const SHOW_DASHBOARD = 'SHOW_DASHBOARD';
